import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import React from 'react';
import typographyGenerator from './generator';
import { IBaseTypography, lineHeights, textStyles } from './types';

const Text = styled.p<{type: textStyles, lineHeight: lineHeights}>`
	${((props) => typographyGenerator(props.type, props.lineHeight, theme))}
`;

export interface ITextProps extends IBaseTypography {
	children: any;
}

const renderText = ({ children, type, lineHeight, className }: ITextProps) => {
	return <Text type={type} lineHeight={lineHeight} className={className}>{children}</Text>;
};

// className allows styled() wrapper to be used
const Wrapper: React.FC<ITextProps> = ({ children, type, lineHeight, className }) => {
	return renderText({ children, type, lineHeight, className });
};

export default Wrapper;
